import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/style.css';

function Header() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="custom-header">
      <div className="container">
        <div className="header-content">
          <Link className="header-brand" to="/">Anusha Ravichandran</Link>
          <button className="header-nav-toggle" onClick={toggleMenu}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
          <nav className={`header-nav ${isOpen ? 'active' : ''}`}>
            <Link className="header-nav-link" to="/">Home</Link>
            <Link className="header-nav-link" to="/education">Education</Link>
            <Link className="header-nav-link" to="/work-experience">Experience</Link>
            <Link className="header-nav-link" to="/projects">Projects</Link>
            <Link className="header-nav-link" to="/contact">Contact</Link>
          </nav>
        </div>
      </div>
    </header>
  );
}

export default Header;
